import React from 'react'
import { sanitizeHTML } from '../../../../utils/common-utils'
import { Card } from '../Card/Card'
import { CardGridProps } from './CardGrid.type'

export const CardGrid = (props: CardGridProps) => {
  const {
    componentSpacing,
    cardLimit,
    cardList,
    cardGridHeadline,
    cardDescription,
    button,
    brandExtension,
  } = props

  const buildButton = () => {
    const { linkHref, linkTarget, analytics, linkText } = button ?? {}
    return (
      <a
        className='Button Button--secondary--action-blue Button--small'
        href={linkHref}
        target={linkTarget}
        data-analytics={analytics ?? ''}>
        {linkText}
      </a>
    )
  }

  if (!cardList) {
    return null
  }

  return (
    <section
      className={`card-grid-component ${componentSpacing} ${brandExtension}`}
      data-limit={cardLimit}>
      <div
        className='u-sizeConstrained u-sm-flexCol u-sm-flexJustifyCenter'
        data-testid={props.testId ?? null}>
        <div className='u-flex u-flexJustifyBetween'>
          {cardGridHeadline && (
            <h2 className='u-textColorDefault u-marginBottom3gu'>{cardGridHeadline}</h2>
          )}
          {button && <div className='Button--customSmallHidden'>{buildButton()}</div>}
        </div>
        {cardDescription && (
          <div
            className='card-description Content u-marginBottom4gu'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(cardDescription) }}
          />
        )}
        <div className='card-list-wrapper u-sm-flex u-sm-flexCol u-marginBottom4gu'>
          {cardList.map(card => (
            <Card key={card.cardId} card={card} />
          ))}
        </div>
        {button && (
          <div className='u-flex u-flexJustifyCenter Button--customSmallShow u-md-hidden u-lg-hidden'>
            {buildButton()}
          </div>
        )}
      </div>
    </section>
  )
}
